import client from '../lib/http-client';
import { buildQuery } from '../lib/helper';

const endpoint = '/shipping';

export default {
	// Province List
	getAllProvinces(cb, errorCb) {
		const url = `${endpoint}/province?province_id=0`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// City List
	getCities(params, cb, errorCb) {
		// const url = `${endpoint}/city?province_id=${provinceId}`;
		const url = `${endpoint}/city`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// District List
	getDistricts(cityId, cb, errorCb) {
		const url = `${endpoint}/district?city_id=${cityId}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Subdistrict List
	getSubdistricts(cityId, cb, errorCb) {
		const url = `${endpoint}/subdistrict?city_id=${cityId}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Search Subdistricts
	searchSubdistricts(params, cb, errorCb) {
		const url = `${endpoint}/subdistricts`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update Subdistrict
	updateSubdistrict(id, params, cb, errorCb) {
		const url = `${endpoint}/subdistricts/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Search Cities
	searchCities(params, cb, errorCb) {
		const url = `${endpoint}/cities`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update City
	updateCity(id, params, cb, errorCb) {
		const url = `${endpoint}/cities/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Subdistrict List with Origin
	getSubdistrictsWithOrigin(params, cb, errorCb) {
		const url = `${endpoint}/subdistrict`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Complete Subdistricts
	getCompleteSubdistricts(params, cb, errorCb) {
		const url = `${endpoint}/complete_district`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Complete City
	getCompleteCities(params, cb, errorCb) {
		const url = `${endpoint}/complete_city`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Complete City Grouped by Province
	getCompleteCitiesGrouped(params, cb, errorCb) {
		const url = `${endpoint}/complete_city_grouped`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Shipping Costs
	getCosts(params, cb, errorCb) {
		/**
		 * Params
		 * - origin : String Object of City
		 * - destination : String Object of Subdistrict
		 * - couriers : String Array of Couriers
		 * - product : String Object with weight property
		 */
		const url = `${endpoint}/cost`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Shipping Costs
	getShippingCosts(params, cb, errorCb) {
		/**
		* Params
		* - origin_id : Subdistrict ID
		* - destination_id : Subdistrict ID
		* - couriers : String Array of Couriers
		* - weight : Int, on gram
		*/
		const url = 'https://shipment.orderonline.id/shipping_costs';
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Request Pickup
	requestPickup(params, cb, errorCb) {
		const url = `${endpoint}/pickup`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	// Pickup Support
	pickupSupport(params, cb, errorCb) {
		const url = `${endpoint}/pickup/support`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Pickup Support Index
	indexPickupSupport(params, cb, errorCb) {
		const url = `${endpoint}/pickup/support`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update Pickup SUpport
	updatePickupSupport(id, params, cb, errorCb) {
		const url = `${endpoint}/pickup/support/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Request Smart Pickup
	requestSmartPickup(params, cb, errorCb) {
		const url = `${endpoint}/smart_pickup`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Shipment List
	getList(params, cb, errorCb) {
		const url = endpoint;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Shipment Orders List
	getOrdersList(params, cb, errorCb) {
		const url = `${endpoint}/orders`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get All Shipment Orders List - Admin Only
	getAllOrdersList(params, cb, errorCb) {
		const url = `${endpoint}/admin/orders`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Incomplete Shipments
	getIncompletes(params, cb, errorCb) {
		const url = `${endpoint}/incomplete`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get All Shipment List
	getAllList(params, cb, errorCb) {
		const url = `${endpoint}/all`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export List
	exportList(params, cb, errorCb) {
		const url = `${endpoint}/export`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export logistic shipping
	exportLogistic(params, cb, errorCb) {
		const url = `${endpoint}/export_logistic`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Export logistic shipping
	exportLogisticByAdmin(params, cb, errorCb) {
		const url = `${endpoint}/admin/export`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Orders
	getOrders(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Orders (Admin Only)
	getOrdersByAdmin(id, params, cb, errorCb) {
		const url = `${endpoint}/admin/${id}`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Orders
	track(orderId, cb, errorCb) {
		const url = `${endpoint}/track/${orderId}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update
	updatePickup(id, params, cb, errorCb) {
		const url = `${endpoint}/pickup/${id}/status`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Export Logistic Delivery
	 *
	 * @param {Object} params
	 * @param {'delivered', 'processing', 'failed'} params.delivery_status Delivery Status
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	exportLogisticDelivery(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export/delivery_city?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Export Admin Logistic Delivery
	 *
	 * @param {Object} params
	 * @param {'delivered', 'processing', 'failed'} params.delivery_status Delivery Status
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	exportAdminLogisticDelivery(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/admin/export/delivery_city?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},
};
